import React, { createContext, useContext, useEffect, useState } from 'react';
import { getNormalizationDataFlag } from '../../utils/apiRequests';
import { SPEND_TYPE } from '../../Data/constants';

const Normalization = createContext();

export const NormalizationProvider = ({ children }) => {
	const [isLoading, setIsLoading] = useState(false);
	const [currentRoute, setCurrentRoute] = useState('');
	const [existingRoute, setExistingRoute] = useState('');

	useEffect(() => {
		getFlag();
	}, []);

	useEffect(
		() => {
			setCurrentRoute(existingRoute);
		},
		[existingRoute]
	);

	const getFlag = async () => {
		try {
			const response = await getNormalizationDataFlag();
			if (response.succeeded) {
				if (response.data.length === 0) {
					setExistingRoute(SPEND_TYPE.INDIRECT);
				} else {
					const routeWith =
						response.data[0]?.isDirect === false
							? SPEND_TYPE.INDIRECT
							: SPEND_TYPE.DIRECT;
					setExistingRoute(routeWith);
				}
			}
		} catch (error) {
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<Normalization.Provider
			value={{
				isLoading,
				currentRoute,
				existingRoute,
				setCurrentRoute,
			}}
		>
			{children}
		</Normalization.Provider>
	);
};

export const useNormalizationContext = () => {
	return useContext(Normalization);
};
